import React from 'react';
import {useIntl} from 'react-intl';
import {useStore} from 'react-redux';

import {baseTranslatedEnumValueParams} from 'src/js/common/raw_rendering';
import {TranslateEnumParams} from 'src/js/common/types';

type Props = TranslateEnumParams;

export const TranslatedEnumValue: React.FC<Props> = (props) => {
  const intl = useIntl();
  const store = useStore();

  const {plainTranslatedValue} = baseTranslatedEnumValueParams(props, {
    intl,
    store,
  });

  return plainTranslatedValue ? <span>{plainTranslatedValue}</span> : null;
};

TranslatedEnumValue.displayName = 'TranslatedEnumValue';
